import React from 'react';
import { Modal } from '@forecast-it/design-system';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
const ExitActionBarModal = ({ closeModal, callback }) => {
    const onClickConfirm = () => {
        callback();
        closeModal();
    };
    return (React.createElement(Modal, { size: Modal.SIZE.SMALL, onCloseModal: closeModal },
        React.createElement(Modal.Title, null,
            React.createElement(FormattedMessage, { id: 'action_bar.title' })),
        React.createElement(Modal.Content, null,
            React.createElement(FormattedHTMLMessage, { id: 'action_bar.description' })),
        React.createElement(Modal.Footer, null,
            React.createElement(Modal.PrimaryFooterButton, { onPress: onClickConfirm, dataCy: 'modal-btn-confirm' },
                React.createElement(FormattedMessage, { id: "common.confirm" })),
            React.createElement(Modal.SecondaryFooterButton, { onPress: closeModal },
                React.createElement(FormattedMessage, { id: "common.go_back" })))));
};
export default ExitActionBarModal;
